import React from "react";
import { Link } from "react-router-dom";
import "./NavButtons.css";

export default function NavButtons() {
  return (
    <div className="nav-buttons">
      <Link to="/" className="nav-btn">Whiteboard</Link>
      <Link to="/morph" className="nav-btn">Morph Loop</Link>
      <Link to="/asmr" className="nav-btn">ASMR Calm</Link>
      <Link to="/asmr2" className="nav-btn">Ghibli ASMR</Link>
    </div>
  );
}
